import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components/_atoms/button";
import { NotFoundView } from "@/components/_molecules/not-found-view";
import { signout } from "@/domain/_shared/auth/services/auth.service";

import { WORKSPACE_PICKER_PATH } from "../lib/workspace-picker-path";

export function WorkspaceSsoRequiredView() {
  const { t } = useTranslation("common");
  const navigate = useNavigate();

  return (
    <NotFoundView title={t("workspaceSsoRequired.title")} text={t("workspaceSsoRequired.description")}>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Button variant="outline" onClick={() => signout()}>
          {t("workspaceSsoRequired.logout")}
        </Button>
        <Button variant="default" onClick={() => navigate(WORKSPACE_PICKER_PATH)}>
          {t("workspaceSsoRequired.toOverview")}
        </Button>
      </div>
    </NotFoundView>
  );
}
